import { render, staticRenderFns } from "./our-curated-selections.vue?vue&type=template&id=e8c22f10&scoped=true"
import script from "./our-curated-selections.vue?vue&type=script&lang=js"
export * from "./our-curated-selections.vue?vue&type=script&lang=js"
import style0 from "./our-curated-selections.vue?vue&type=style&index=0&id=e8c22f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c22f10",
  null
  
)

export default component.exports